export default __webpack_public_path__ + "static/media/Phisical Inventory2.a14db444.svg";